exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MuiTabs-flexContainer button{\r\n    width     : 50px !important;\r\n   \r\n}\r\n\r\n.MuiTabs-root {\r\n    min-width: 110px !important;\r\n}\r\n.inline-items .btn-toolbar{\r\n    padding : 0 !important; \r\n}", ""]);

